import React, {FC, useContext, useEffect, useState} from 'react';
import {connect} from "react-redux";
import {Modal, Icon, Button} from 'semantic-ui-react';
import GlobalContext from "../../../contexts/GlobalContext";
import './ModalSuccessSelfCheckin.css';

const mapProps = (state) => ({
  isModalOpen: state.modal.successSelfCheckinModal
});
const mapDispatch = (dispatch) => ({
  handleModal: dispatch.modal.handleModal
})

type Props = {
  isModalOpen: boolean
  handleModal: any
} & ReturnType<typeof mapProps> & ReturnType<typeof mapDispatch>

const ModalSuccessPreCheckin: FC<Props> = ({
  isModalOpen,
  handleModal
}) => {
  const [globalContext] = useContext(GlobalContext) as any;
  const [modalOpenState, setModalOpenState] = useState(isModalOpen);

  useEffect(() => {
    setModalOpenState(isModalOpen);
  }, [isModalOpen])

  return (
    <Modal
      id="modalSuccessPreCheckin"
      dimmer="inverted"
      size="tiny"
      open={modalOpenState}
      className="modalTransition"
    >
      <Modal.Header>
        <h1>{globalContext.translations.preCheckinBookingCompletionSucessTitle}</h1>
        <div className="successIconContainer"><Icon className="successIcon" color='green' size="massive" name="check circle" /></div>
        <Icon name="close" className="float-right" id="iconDeleteModal" onClick={() => handleModal({successSelfCheckinModal: false})} />
      </Modal.Header>
      <Modal.Content>
        <p>{globalContext.translations.preCheckinBookingCompletionSucessLabel}</p>
      </Modal.Content>
      <Modal.Content>
        <p>Affichage du service permettant de récupérer l'accès à la chambre (preCheckinListServiceSuccess)</p>
      </Modal.Content>
      <Modal.Actions className="actionsContainer">
        <Button
          onClick={() =>  handleModal({successSelfCheckinModal: false})}
          content={globalContext.translations.valid}
          positive
        />
      </Modal.Actions>
    </Modal>

  )
}

export default connect(mapProps, mapDispatch)(ModalSuccessPreCheckin);